// Arabic translations (RTL).
const ar = {
  ui: {
    brand: "My World Quest",
    brand_subtitle: "لوّن وتعلّم",
    nav: {
      home: "الرئيسية", countries: "البلدان", globe: "الكرة", continents: "القارات",
      color: "تلوين", puzzles: "ألغاز", games: "ألعاب", quiz: "اختبار", parents: "الآباء",
      math: "رياضيات الجغرافيا",
      "geo-lines": "خطوط العالم", "maths-academy": "أكاديمية الرياضيات",
      more: "المزيد",
      advanced: "تحديات متقدمة",
      ask: "اسأل الكرة ✨",
      campaigns: "المهام",
      "dream-trip": "رحلة الأحلام",
      "hub-learn": "استكشف",
      "hub-create": "أبدع",
      "hub-play": "العب",
      "hub-discover": "مغامرة",
      knowledge: "مغامرات موضوعية",
      passport: "جواز سفري",
      stickers: "الملصقات",
      trip: "رحلة",
      "spelling-bee": "نحلة التهجئة",
      "mandala": "استوديو الماندالا",
      "admin-lessons": "إدارة الدروس",
      "admin-questions": "إدارة بنك الأسئلة",
      "learning-plan": "خطة التعلم",
      "term-report": "تقرير الفصل",
      "teacher": "لوحة المعلم",
      "quest-games": "ألعاب المهمة",
      "coloring": "تلوين",
      "pixel-art": "فن البكسل",
      "flag-artist": "فنان الأعلام",
      "printables": "أوراق للطباعة",
      "play-home": "الصفحة الرئيسية للعب",
      "learn-topics": "مواضيع التعلم",
    },
    accessibility: { bigText: "نص كبير", highContrast: "تباين عالٍ" },
    navGroups: { quick: "سريع", explore: "استكشف", play: "العب وتعلم", collect: "اجمع", adv: "مغامرة", grownup: "للكبار" },
    actions: { back: "رجوع", close: "إغلاق", reset: "إعادة", save: "حفظ", retry: "حاول مجدداً", playAgain: "العب مرة أخرى" },
  },
  microcopy: {
    great: "أحسنت! ⭐",
    correct: "✅ صحيح!",
    nope: "حاول مرة أخرى!",
    tryAgain: "ليس تماماً. استمر!",
    awesome: "رائع!",
    welcome: "مرحباً بك في {{country}}! لنتعلم {{language}}.",
    allPlaced: "تم وضع الكل! 🎉",
    youDidIt: "لقد فعلتها!",
    perfect: "ممتاز!",
  },
  home: {
    streak: "سلسلة: {{n}} يوم",
    streak_plural: "سلسلة: {{n}} أيام",
    subtitleShort: "مساعدة الأطفال على استكشاف البلدان والثقافات والمعالم والقارات من خلال مغامرات تفاعلية.",
    tagline: "من وقت الشاشة إلى وقت الاكتشاف",
    title1: "اكتشف العالم",
    title2: "بلداً واحداً في كل مرة",
    subtitle: "مغامرات جغرافية ممتعة، اختبارات، تحديات ومكافآت تساعد الأطفال على اكتشاف البلدان والثقافات والأعلام والمعالم والمزيد.",
    playNow: "العب الآن ←",
    takeQuiz: "اختبر نفسك",
    countryOfTheDay: "🌟 بلد اليوم",
    discover: "اكتشف {{name}}!",
    letsGo: "هيا بنا",
    whatNext: "ماذا تريد أن تفعل اليوم؟",
    whatNextSub: "اختر أي شيء — كله ممتع!",
    tiles: {
      learn: "تعلم البلدان", learnDesc: "أكثر من 30 بلداً مع الأعلام!",
      globe: "كرة ثلاثية الأبعاد", globeDesc: "أدر واضغط لتستكشف",
      continents: "القارات", continentsDesc: "استكشف القارات السبع",
      color: "لوّن المعالم", colorDesc: "لوّن برج إيفل!",
      puzzles: "ألغاز", puzzlesDesc: "ألغاز انزلاقية وخريطة",
      games: "العب الألعاب", gamesDesc: "طابق البلدان والقارات",
      quiz: "وقت الاختبار", quizDesc: "اختبار سهل ومتقدم",
      parents: "للآباء", parentsDesc: "اطلع على تقدم طفلك",
    },
    stats: { stars: "نجوم", countries: "بلدان", badges: "شارات", streak: "سلسلة" },
  },
  daily: {
    label: "تحدّي اليوم",
    streakLabel: "السلسلة {{n}}",
    todayDone: "أكملت اليوم!",
    threeQuick: "3 أسئلة سريعة",
    descUnlocked: "حل 3 أسئلة مقابل 3 ⭐ + مكافأة السلسلة (حتى +5 ⭐).",
    descDone: "حصلت على {{score}}. عد غداً للحصول على +1 ⭐ إضافية!",
    start: "ابدأ ←",
    done: "تم",
    finished: "أنهيت تحدي اليوم!",
    score: "النتيجة:",
    streakSuffix: "يوم",
    streakSuffix_plural: "أيام",
    bonus: "(+{{n}} مكافأة!)",
  },
  learn: {
    title: "تعلم البلدان 🌍",
    subtitle: "اضغط على أي بطاقة بلد لتتعلم عنها. اضغط على السماعة لتسمع بصوت عالٍ!",
    searchPlaceholder: "ابحث عن بلد أو عاصمة أو معلم…",
    clear: "مسح",
    filterAll: "الكل",
    hello: "مرحباً",
    capital: "العاصمة", language: "اللغة",
    learnedBtn: "تعلمتها! ⭐",
    learnLang: "تعلم اللغة",
    noResults: "لم يتم العثور على بلدان. جرب بحثاً آخر!",
    goalsEyebrow: "أهداف التعلم لليوم",
    goalsHeading: "🎯 ركّز على هذه أولاً",
    goalsSubtitle: "أهم أربعة أشياء يجب إتقانها في عمر {{tier}} — مختارة من المنهج.",
    goalsAllTopics: "عرض كل المواضيع",
    goalsLearnNow: "تعلم الآن",
    goalsKey: "مفتاح #{{n}}",
    topicTitles: {
      "art-design": "الرسم والتلوين والتصميم",
      "music": "الموسيقى: الإيقاع والغناء والنوتة",
      "computing-code": "البرمجة والخوارزميات والأمان الرقمي",
      "physical-education": "التربية البدنية والصحة واللياقة",
      "world-religions": "أديان العالم والمعتقدات",
      "wellbeing-relationships": "الصحة والمشاعر والصداقات",
    },
  },
  continents: {
    title: "خرائط القارات 🗺️",
    subtitle: "اضغط على قارة لتكتشف بلدانها ومعلومات ممتعة!",
    countriesIn: "بلدان في {{name}}:",
    learnMore: "تعلم المزيد من البلدان ←",
  },
  coloring: {
    title: "لوّن المعالم 🎨",
    subtitle: "{{n}} معلماً للتلوين. أو حمّل أوراق العمل القابلة للطباعة!",
    printOne: "اطبع هذا",
    printAll: "حمّل كل PDF",
    tools: "أدوات",
    colors: "ألوان",
    fill: "تعبئة", pencil: "قلم", erase: "ممحاة",
    undo: "تراجع", redo: "إعادة",
    sub: "اضغط على بلاطة بجانب الفراغ لتحرّكها. أعد بناء {{name}}!",
  },
  games: {
    title: "طابق البلد! 🎮",
    subtitle: "اسحب (أو اضغط) علم بلد إلى قارته.",
    newGame: "🔄 لعبة جديدة",
    dragFlags: "اسحب هذه الأعلام 👇",
  },
  quiz: {
    title: "وقت الاختبار! 🧠",
    subtitle: "اختر مستوى. تستطيع!",
    basic: "اختبار سهل",
    advanced: "اختبار متقدم",
    basicDesc: "5 أسئلة سهلة عن البلدان والقارات.",
    advancedDesc: "10 أسئلة صعبة. هل أنت مستعد؟",
    upTo: "حتى {{n}} ⭐",
    question: "السؤال {{i}} / {{n}}",
    backToMenu: "العودة إلى القائمة",
    perfect: "ممتاز!",
    greatJob: "أحسنت!",
    youGot: "حصلت على",
    outOf: "من",
  },
  parents: {
    title: "لوحة التقدّم 👨‍👩‍👧",
    subtitle: "تابع رحلة تعلّم طفلك.",
    parentsOnly: "للآباء فقط",
    mathPrompt: "أجب على هذا السؤال للدخول.",
    unlock: "افتح",
    wrong: "همم، حاول مرة أخرى!",
    resetProgress: "إعادة التقدّم",
    resetConfirm: "إعادة كل التقدّم؟ لا يمكن التراجع.",
    badges: "الشارات",
    recentActivity: "النشاط الأخير",
    noActivity: "لا نشاط بعد. حان وقت الاستكشاف!",
    notYet: "ليس بعد",
    certTitle: "شهادة الاستكشاف!",
    certBody: "حصل طفلك على {{stars}} نجمة واستكشف {{countries}} بلداً.",
    printCert: "🖨️ اطبع الشهادة",
    statsLabels: {
      stars: "النجوم المكتسبة", streak: "سلسلة الأيام", countries: "البلدان المتعلَّمة",
      quizzes: "الاختبارات المنجزة", games: "الألعاب المربوحة", coloring: "صفحات التلوين",
    },
  },
  lang: {
    title: "تعلم {{language}}",
    sub: "من {{country}}! اضغط على أي عبارة لتسمعها.",
    welcome: "مرحباً",
    finish: "انتهيت! ⭐⭐",
    awesome: "تدريب رائع!",
    finishSub: "أنهِ الدرس لتربح نجمتين.",
    tapToHear: "اضغط لتسمع",
    speakTitle: "🎙️ انطق الكلمة",
    speakSubtitle: "اضغط على الميكروفون وانطق كل عبارة بصوت عالٍ!",
    speakUnsupported: "وضع الصوت يحتاج Chrome أو Edge أو Safari iOS 14+.",
    listening: "أستمع…",
    tapMic: "اضغط على الميكروفون وقل:",
    wellDone: "أحسنت!",
    tryItAgain: "حاول نطقها مرة أخرى",
    youSaid: "قلت:",
    expected: "المتوقّع:",
    phrases: {
      Hello: "مرحباً", "Thank you": "شكراً", Goodbye: "وداعاً",
      Yes: "نعم", No: "لا", One: "واحد", Two: "اثنان", Three: "ثلاثة",
    },
  },
  globe: {
    title: "الكرة الأرضية 🌐",
    subtitle: "أدر العالم. الدبابيس المضيئة بلدان للاستكشاف. الدبابيس الذهبية بلدان تعلمتها!",
    learnedCounter: "{{n}} / {{total}} تم تعلّمها",
    spinTap: "أدر واضغط!",
    spinTapSub: "اضغط على أي دبوس مضيء لتكتشف بلداً.",
    learnedTag: "⭐ متعلَّم",
    moreInfo: "مزيد ←",
    learnLang: "🗣️ تعلم اللغة",
  },
  puzzles: {
    title: "ألغاز 🧩",
    subtitle: "اختر نوع لغز والعب!",
    sliding: "🖼️ لغز انزلاقي",
    shape: "🗺️ لغز خريطة",
    placed: "{{done}} / {{total}} موضوعة",
    tapPrompt: "اضغط على علم، ثم اضغط على المكان الصحيح.",
    tapNext: "الآن اضغط على المكان الصحيح ←",
    moves: "حركات: {{n}}",
    best: "الأفضل: {{n}}",
    shuffle: "اخلط",
    solvedIn: "🎉 حللتها بـ {{n}} حركات!",
    newBest: "🏁 رقم قياسي جديد {{n}} حركات!",
    record: "رقمك القياسي: {{n}} حركات",
  },
  certificate: {
    title: "🎉 جوّال العالم!",
    body: "واو! تعلّمت {{n}} بلداً. أنت جوّال عالم حقيقي!",
    print: "🖨️ اطبع شهادتي",
    keep: "تابع الاستكشاف",
  },
  langSwitcher: {
    label: "اللغة",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية",
  },
  common: {
    whereToNext: "إلى أين الآن؟",
    home: "الرئيسية",
    earnMoreStars: "⭐ اكسب المزيد من النجوم",
    earnHowTo: "العب لعبة سريعة — كل واحدة تضيف نقاط خبرة!",
    pickAge: "اختر العمر",
    ages: "الأعمار",
    startExploring: "ابدأ الاستكشاف",
    pickAnywhere: "اختر من الأعلى — أو اضغط هنا!",
    tapAnyCountry: "اضغط على أي دولة لتتعرف على قصتها!",
    exploreGlobe: "استكشف الكرة الأرضية",
    exploreGlobeSub: "مغامرة ثلاثية الأبعاد",
  },
  shortcuts: {
    home: "الرئيسية",
    continents: "القارات",
    globe: "الكرة الأرضية",
    ask: "اسأل",
    landmarks: "المعالم",
    flags: "الأعلام",
    pixel: "بكسل",
    puzzles: "الألغاز",
    math: "الرياضيات",
    trip: "الرحلة",
    quiz: "اختبار",
    quests: "المهام",
    stickers: "ملصقات",
    miniGames: "ألعاب صغيرة",
    geoMath: "جغرافيا الرياضيات",
    quickQuiz: "اختبار سريع",
    myTrophies: "كؤوسي",
    colorCreate: "لوّن وأبدع",
    spinGlobe: "أدر الكرة الأرضية",
    askGlobe: "اسأل الكرة الأرضية",
    dreamTrip: "رحلة الأحلام",
    earnStars: "اكسب نجوماً",
    tryAQuest: "جرّب مهمة",
    playAgain: "العب مرة أخرى",
    learnCountry: "تعلم بلداً",
    colorLandmark: "لوّن معلماً",
    learnCountries: "تعلم البلدان",
    advanced: "الوضع المتقدم",
    spellCountry: "اكتب اسم دولة",
    advancedHub: "المنطقة المتقدمة",
    squishyHop: "قفز سكويشي",
    mathSnap: "ماث سناب",
    language: "اللغة",
    geoLines: "خطوط العالم",
  },
  coloringExtra: {
    modeLandmarks: "المعالم",
    modeFlags: "فنان الأعلام",
    modePixel: "فن البكسل",
    modeMandala: "ماندالا",
    diffEasy: "سهل",
    diffMedium: "متوسط",
    diffExpert: "خبير",
    difficultyLabel: "الصعوبة:",
  },
  tilesExtra: {
    labelLearn: "تعلم",
    labelCreate: "أبدع",
    labelPlay: "العب",
    labelTrophies: "الكؤوس",
    whatNextSub: "اختر أي شيء — كله ممتع!",
  },
  pills: {
    orTry: "أو جرّب ↓",
    
    squishyHop: "قفزة المرنة",
    mathSnap: "سناب الرياضيات",colorLandmark: "لوّن معلماً",
    solvePuzzle: "حلّ لغزاً",
    dreamTrip: "خطط لرحلة أحلام",
    geoMath: "جرّب جغرافيا الرياضيات",
    continentQuests: "مهام القارات",
    stickerBook: "ألبوم الملصقات",
    famousPeople: "تعرّف على مشاهير",
    culturalSpot: "بقعة ثقافية",
    quickQuiz: "اختبار سريع",
    continentMaps: "خرائط القارات",
    spellCountry: "اكتب اسم دولة",
    flagArtist: "فنان الأعلام",
    pixelArt: "فن البكسل",
    spinGlobe: "أدر الكرة الأرضية",
    askGlobe: "اسأل الكرة الأرضية",
    myTrophies: "كؤوسي",
    advancedHub: "المنطقة المتقدمة",
    geoLines: "خطوط العالم",
  },
  canvas: {
    tools: "الأدوات",
    brushSize: "حجم الفرشاة",
    colors: "الألوان",
    patterns: "الأنماط",
    modes: "الأوضاع",
    solid: "صلب",
    anyColor: "أي لون",
    recent: "حديث",
    sticker: "ملصق",
    symmetry: "التناظر",
    colorByNumber: "لون بالأرقام",
    reference: "مرجع",
    undo: "تراجع",
    redo: "إعادة",
    reset: "إعادة تعيين",
    replay: "إعادة",
    check: "تحقق",
    save: "حفظ",
    fill: "ملء",
    pencil: "قلم",
    stamp: "ختم",
    erase: "مسح",
    on: "نعم",
    off: "لا",
    tool: "أداة:",
    pattern: "نمط:",
    printOne: "طباعة",
    downloadAll: "تحميل الكل",
    appTitle: "لوّن وأبدع 🎨",
    appSub: "فرش، أنماط، ملصقات، تلوين بالأرقام والمزيد!",
  },
  trust: {
    aria: "وعود سلامة الأطفال",
    noAds: "لا إعلانات. أبدًا.",
    noIap: "لا مشتريات داخل اللعبة.",
    noChat: "لا محادثات، لا غرباء.",
    anyDevice: "يعمل على أي جهاز.",
  },
  lens: {
    kicker: "استكشف حسب",
    subtitle: "اختر طريقة الاستكشاف",
    animals: "الحيوانات",
    places: "الأماكن",
    inventions: "الاختراعات",
    cultures: "الثقافات",
    food: "الطعام",
    maps_and_worlds: "الخرائط والعوالم",
  },
  passport: {
    stampsTitle: "مجموعة الطوابع",
    stampsSub: "طابع واحد لكل مهمة أتقنتها.",
    stampsEmpty: "لا توجد طوابع بعد — أنهِ أول تجربة إتقان بثلاث نجوم!",
    stampsCount: "{{n}} طوابع",
    stampsCount_one: "{{n}} طابع",
  },
};

export default ar;
